<template>
	<div class="gestionar-propuestas-compras-page propuesta-historica-page">
		<div class="propuesta-container" v-if="propuesta.id">
			<!-- Header de la propuesta -->
			<div class="propuesta-header">
				<div class="header-row">
					<div class="header-field">
						<label>BUQUE:</label>
						<el-input v-model="propuesta.buqueNombre" size="small" :disabled="true" readonly />
					</div>
					<div class="header-field">
						<label>{{ propuesta.tipo === 'PUENTE' ? 'CAPITAN:' : 'J.MAQUINAS:' }}</label>
						<el-input v-model="propuesta.jMaquinas" size="small" :disabled="true" readonly />
					</div>
					<div class="header-field header-title">
						<h2>{{ propuesta.tipo === 'PUENTE' ? 'PROPUESTA PUENTE - HISTÓRICA' : 'PROPUESTA MAQUINAS - HISTÓRICA' }}</h2>
					</div>
					<div class="header-field">
						<label>FECHA:</label>
						<el-input v-model="propuesta.fecha" size="small" :disabled="true" readonly />
					</div>
					<div class="header-field">
						<label>N° PROPUESTA PED.:</label>
						<el-input v-model="propuesta.numeroPropuesta" size="small" :disabled="true" readonly />
					</div>
				</div>
			</div>

			<!-- Tabla de propuesta -->
			<div class="propuesta-table-container">
				<div class="table-header">
					<div class="col-posicion">POSICION</div>
					<div class="col-referencia">REFERENCIA</div>
					<div class="col-equipo">EQUIPO (MODELO, SN,_)</div>
					<div class="col-ped-barco">Ped. Barco</div>
					<div class="col-ped-compras">Ped. Compras</div>
					<div class="col-precio">Precio</div>
					<div class="col-proveedor">Proveedor Compra</div>
					<div class="col-estado">Estado</div>
					<div class="col-notas">Notas BARCO</div>
					<div class="col-anotaciones-tecnico">Anotaciones Dpt. Técnico</div>
					<div class="col-pedido">Pedido</div>
					<div class="col-fecha-entrega">Fecha Entrega aprox</div>
				</div>

				<!-- Grupos y líneas para MAQUINAS -->
				<template v-if="propuesta.tipo === 'MAQUINAS'">
					<div
						v-for="grupo in gruposConLineas"
						:key="grupo.id"
						class="grupo-section"
						:class="`grupo-${(grupo.codigo || '').toLowerCase()}`"
					>
						<div class="grupo-header" @click="toggleGrupo(grupo.id)" :class="{'grupo-collapsed': !grupo.visible}">
							<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
						</div>
						<template v-if="grupo.visible">
							<div v-for="(linea, index) in grupo.lineasVisibles" :key="`${grupo.id}-${index}`" class="table-row">
								<div class="col-posicion">{{ linea.posicion }}</div>
								<div class="col-referencia">{{ linea.referencia || '-' }}</div>
								<div class="col-equipo">{{ linea.equipo || '-' }}</div>
								<div class="col-ped-barco">
									<div>
										{{ (linea.cantidad !== '' && linea.cantidad != null ? linea.cantidad : '-') }} {{ linea.unidad || '' }}
									</div>
								</div>
								<div class="col-ped-compras">
									<div>
										{{ (linea.cantidadCompras !== '' && linea.cantidadCompras != null ? linea.cantidadCompras : '-') }} {{ linea.unidadMedidaCompras || '' }}
									</div>
								</div>
								<div class="col-precio">{{ linea.precio !== '' ? linea.precio : '-' }}</div>
								<div class="col-proveedor">{{ linea.proveedor || '-' }}</div>
								<div class="col-estado">
									<el-tag v-if="linea.tieneOrdenCompra" type="warning" size="small"><i class="el-icon-document"></i> OC</el-tag>
									<el-tag v-else-if="linea.tieneOferta" type="success" size="small"><i class="el-icon-message"></i> Oferta</el-tag>
									<el-tag v-else :type="linea.estado === 2 ? 'success' : (linea.estado === 4 ? 'info' : 'default')" size="mini">{{ labelEstado(linea.estado) }}</el-tag>
								</div>
								<div class="col-notas">{{ linea.notas || '-' }}</div>
								<div class="col-anotaciones-tecnico">{{ linea.anotacionesTecnico || '-' }}</div>
								<div class="col-pedido">{{ linea.codigoOrdenCompra || '-' }}</div>
								<div class="col-fecha-entrega">{{ formatFechaEntrega(linea.fechaEntregaAprox) }}</div>
							</div>
						</template>
					</div>
				</template>

				<!-- Secciones y grupos para PUENTE -->
				<template v-else-if="propuesta.tipo === 'PUENTE'">
					<div
						v-for="seccion in seccionesConLineas"
						:key="seccion.id"
						class="seccion-section"
						:class="`seccion-${(seccion.nombre || '').toLowerCase()}`"
					>
						<div class="seccion-header" :class="[`seccion-${(seccion.nombre || '').toLowerCase()}`]" @click="toggleSeccion(seccion.id)">
							<i :class="seccion.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<span>{{ seccion.nombre }} ({{ contarLineasSeccion(seccion) }})</span>
						</div>
						<template v-if="seccion.visible">
							<div
								v-for="grupo in seccion.grupos.filter(g => contarLineasGrupo(g) > 0)"
								:key="grupo.id"
								class="grupo-section"
								:class="`grupo-${(grupo.codigo || '').toLowerCase()}`"
							>
								<div class="grupo-header" @click="toggleGrupoPuente(seccion.id, grupo.id)" :class="{'grupo-collapsed': !grupo.visible}">
									<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
									<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
								</div>
								<template v-if="grupo.visible">
									<div v-for="(linea, index) in grupo.lineasVisibles" :key="`${seccion.id}-${grupo.id}-${index}`" class="table-row">
										<div class="col-posicion">{{ linea.posicion }}</div>
										<div class="col-referencia">{{ linea.referencia || '-' }}</div>
										<div class="col-equipo">{{ linea.equipo || '-' }}</div>
										<div class="col-ped-barco">
											<div>
												{{ (linea.cantidad !== '' && linea.cantidad != null ? linea.cantidad : '-') }} {{ linea.unidad || '' }}
											</div>
										</div>
										<div class="col-ped-compras">
											<div>
												{{ (linea.cantidadCompras !== '' && linea.cantidadCompras != null ? linea.cantidadCompras : '-') }} {{ linea.unidadMedidaCompras || '' }}
											</div>
										</div>
										<div class="col-precio">{{ linea.precio !== '' ? linea.precio : '-' }}</div>
										<div class="col-proveedor">{{ linea.proveedor || '-' }}</div>
										<div class="col-estado">
											<el-tag v-if="linea.tieneOrdenCompra" type="warning" size="small">
												<i class="el-icon-document"></i> OC
											</el-tag>
											<el-tag v-else-if="linea.tieneOferta" type="success" size="small">
												<i class="el-icon-message"></i> Oferta
											</el-tag>
											<el-tag v-else :type="linea.estado === 2 ? 'success' : (linea.estado === 4 ? 'info' : 'default')" size="mini">
												{{ labelEstado(linea.estado) }}
											</el-tag>
										</div>
										<div class="col-notas">{{ linea.notas || '-' }}</div>
										<div class="col-anotaciones-tecnico">{{ linea.anotacionesTecnico || '-' }}</div>
										<div class="col-pedido">{{ linea.codigoOrdenCompra || '-' }}</div>
										<div class="col-fecha-entrega">{{ formatFechaEntrega(linea.fechaEntregaAprox) }}</div>
									</div>
								</template>
							</div>
						</template>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { getUrl } from '@/helpers/api'

export default {
	name: 'PropuestaHistorica',
	props: {
		// Permite renderizar esta vista dentro de ventanas (sin depender de $route)
		id: [String, Number]
	},
	data() {
		return {
			propuesta: {
				id: null,
				buqueId: null,
				buqueNombre: '',
				jMaquinas: '',
				fecha: '',
				numeroPropuesta: '',
				tipo: 'MAQUINAS',
				estado: null
			},
			grupos: [],
			secciones: []
		}
	},
	computed: {
		...mapState({
			user: state => (state.user ? state.user.data : null)
		}),
		gruposConLineas() {
			return this.grupos.filter(grupo => this.contarLineasGrupo(grupo) > 0)
		},
		seccionesConLineas() {
			return this.secciones
				.filter(seccion => seccion.grupos.some(grupo => this.contarLineasGrupo(grupo) > 0))
				.map(seccion => ({
					...seccion,
					grupos: seccion.grupos.filter(grupo => this.contarLineasGrupo(grupo) > 0)
				}))
		}
	},
	async created() {
		// Si viene con un ID por prop o por ruta, cargar directamente esa propuesta
		const idProp = this.id != null && this.id !== '' ? Number(this.id) : null
		const idRuta = (this.$route && this.$route.params && this.$route.params.id) ? Number(this.$route.params.id) : null
		const idInicial = idProp || idRuta
		if (!idInicial) {
			this.$message.error('No se recibió el id de la propuesta')
			return
		}

		await this.cargarPropuestaSeleccionada(idInicial)
	},
	watch: {
		id: {
			immediate: false,
			async handler(val) {
				const n = val != null && val !== '' ? Number(val) : null
				if (!n || n === Number(this.propuesta && this.propuesta.id)) return
				await this.cargarPropuestaSeleccionada(n)
			}
		}
	},
	methods: {
		volverAlDashboard() {
			this.$router.push({ name: 'Dashboard' }).catch(() => {})
		},
		async cargarPropuestaSeleccionada(propuestaId) {
			try {
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}

				const response = await axios.post(
					`${endpoints.backend}entidad/propuestas_pedido/buscador/obtenerPropuesta`,
					{ id: propuestaId }
				)

				if (!response.data || !response.data.cabecera) {
					this.$message.error('Error al cargar la propuesta')
					return
				}

				this.propuesta.id = response.data.id
				this.propuesta.buqueId = response.data.cabecera.buqueId
				this.propuesta.buqueNombre = response.data.cabecera.buque
				this.propuesta.jMaquinas = response.data.cabecera.jefeMaquinas
				this.propuesta.fecha = response.data.cabecera.fecha
				this.propuesta.numeroPropuesta = response.data.cabecera.numeroPropuesta || response.data.codigo
				this.propuesta.tipo = response.data.cabecera.tipo || 'MAQUINAS'
				this.propuesta.estado = 3

				await this.inicializarGrupos()
				await this.$nextTick()

				if (response.data.lineas && Array.isArray(response.data.lineas)) {
					this.cargarLineasDesdeBackend(response.data.lineas)
				}
			} catch (error) {
				console.error('Error al cargar propuesta:', error)
				this.$message.error('Error al cargar la propuesta seleccionada')
			}
		},
		async inicializarGrupos() {
			try {
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}

				const response = await axios.post(
					`${endpoints.backend}entidad/propuestas_pedido/buscador/listarSecciones`,
					{ tipo: this.propuesta.tipo }
				)

				let data = response.data
				if (data && data.data && Array.isArray(data.data)) {
					data = data.data
				} else if (!Array.isArray(data)) {
					this.$message.error('Error en el formato de respuesta del backend')
					return
				}

				if (this.propuesta.tipo === 'PUENTE') {
					this.inicializarGruposPuente(data)
				} else {
					this.inicializarGruposMaquinas(data)
				}
			} catch (error) {
				console.error('Error al cargar grupos desde el backend:', error)
				this.$message.error('Error al cargar los grupos. Por favor, intente nuevamente.')
			}
		},
		inicializarGruposMaquinas(gruposBackend) {
			if (!gruposBackend || !Array.isArray(gruposBackend) || gruposBackend.length === 0) return
			this.grupos = gruposBackend.map(grupo => ({
				id: grupo.id,
				codigo: grupo.codigo,
				nombre: grupo.nombre,
				color: grupo.color,
				lineas: [],
				lineasVisibles: [],
				visible: false
			}))
			this.secciones = []
		},
		inicializarGruposPuente(seccionesBackend) {
			if (!seccionesBackend || !Array.isArray(seccionesBackend) || seccionesBackend.length === 0) return
			this.secciones = seccionesBackend.map(seccion => ({
				id: seccion.id,
				nombre: seccion.nombre,
				color: seccion.color,
				grupos: (seccion.grupos || []).map(grupo => ({
					id: grupo.id,
					codigo: grupo.codigo,
					nombre: grupo.nombre,
					color: grupo.color,
					lineas: [],
					lineasVisibles: [],
					visible: false
				})),
				visible: false
			}))
			this.grupos = []
		},
		cargarLineasDesdeBackend(lineasBackend) {
			if (!lineasBackend || !Array.isArray(lineasBackend) || lineasBackend.length === 0) return

			const gruposConDatos = new Set()
			const seccionesConDatos = new Set()
			const keysLineasAñadidas = new Set()

			lineasBackend.forEach(lineaBackend => {
				const keyLinea =
					lineaBackend && lineaBackend.id != null
						? String(lineaBackend.id)
						: [
							lineaBackend && lineaBackend.grupo ? String(lineaBackend.grupo) : '',
							lineaBackend && lineaBackend.posicion != null ? String(lineaBackend.posicion) : ''
						].join('-')
				if (keysLineasAñadidas.has(keyLinea)) return

				if (this.propuesta.tipo === 'PUENTE') {
					let lineaAñadida = false
					const seccionNombre = lineaBackend.seccion || lineaBackend.seccionNombre

					for (const seccion of this.secciones) {
						if (seccionNombre && seccion.nombre !== seccionNombre) continue

						for (const grupo of seccion.grupos) {
							if (grupo.codigo === lineaBackend.grupo) {
								const tieneOfertaOC = lineaBackend.tieneOferta || lineaBackend.tieneOrdenCompra
								const estadoNorm = this.normalizarEstadoLinea(lineaBackend.estado)
								const linea = {
									id: lineaBackend.id || null,
									idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
									posicion: lineaBackend.posicion,
									referencia: lineaBackend.referencia || '',
									equipo: lineaBackend.equipo || '',
									cantidad: lineaBackend.cantidad || '',
									unidad: lineaBackend.unidad || '',
									cantidadCompras: lineaBackend.cantidadCompras || '',
									unidadMedidaCompras: lineaBackend.unidadMedidaCompras || '',
									notas: lineaBackend.notas || '',
									anotacionesTecnico: lineaBackend.anotacionesTecnico || lineaBackend.ANOTACIONES_TECNICO || '',
									precio: lineaBackend.precio || '',
									proveedorOferta: lineaBackend.proveedorOferta || '',
									proveedorOfertaIds: this.normalizarProveedorOfertaIds(lineaBackend.proveedorOfertaIds, lineaBackend.proveedorOfertaId),
									proveedorId: lineaBackend.proveedorId ? Number(lineaBackend.proveedorId) : (typeof lineaBackend.proveedor === 'number' ? Number(lineaBackend.proveedor) : null),
									proveedor: lineaBackend.proveedor && typeof lineaBackend.proveedor === 'string' ? lineaBackend.proveedor : '',
									tieneOferta: !!lineaBackend.tieneOferta,
									tieneOrdenCompra: !!lineaBackend.tieneOrdenCompra,
									tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento),
									estado: tieneOfertaOC && estadoNorm !== 2 ? 2 : estadoNorm,
									codigoOrdenCompra: lineaBackend.codigoOrdenCompra || lineaBackend.CODIGO_ORDEN_COMPRA || '',
									fechaEntregaAprox: lineaBackend.fechaEntregaAprox || lineaBackend.FECHA_ENTREGA_APROX || ''
								}

								keysLineasAñadidas.add(keyLinea)
								grupo.lineas.push(linea)
								grupo.lineasVisibles.push(linea)
								gruposConDatos.add(`${seccion.id}-${grupo.id}`)
								seccionesConDatos.add(seccion.id)
								lineaAñadida = true

								if (!seccionNombre) break
							}
						}

						if (lineaAñadida && !seccionNombre) break
					}
				} else {
					const grupo = this.grupos.find(g => g.codigo === lineaBackend.grupo)
					if (!grupo) return
					const tieneOfertaOC = lineaBackend.tieneOferta || lineaBackend.tieneOrdenCompra
					const estadoNorm = this.normalizarEstadoLinea(lineaBackend.estado)
					const linea = {
						id: lineaBackend.id || null,
						idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
						posicion: lineaBackend.posicion,
						referencia: lineaBackend.referencia || '',
						equipo: lineaBackend.equipo || '',
						cantidad: lineaBackend.cantidad || '',
						unidad: lineaBackend.unidad || '',
						cantidadCompras: lineaBackend.cantidadCompras || '',
						unidadMedidaCompras: lineaBackend.unidadMedidaCompras || '',
						notas: lineaBackend.notas || '',
						anotacionesTecnico: lineaBackend.anotacionesTecnico || lineaBackend.ANOTACIONES_TECNICO || '',
						precio: lineaBackend.precio || '',
						proveedorOferta: lineaBackend.proveedorOferta || '',
						proveedorOfertaIds: this.normalizarProveedorOfertaIds(lineaBackend.proveedorOfertaIds, lineaBackend.proveedorOfertaId),
						proveedorId: lineaBackend.proveedorId ? Number(lineaBackend.proveedorId) : (typeof lineaBackend.proveedor === 'number' ? Number(lineaBackend.proveedor) : null),
						proveedor: lineaBackend.proveedor && typeof lineaBackend.proveedor === 'string' ? lineaBackend.proveedor : '',
						tieneOferta: !!lineaBackend.tieneOferta,
						tieneOrdenCompra: !!lineaBackend.tieneOrdenCompra,
						tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento),
						estado: tieneOfertaOC && estadoNorm !== 2 ? 2 : estadoNorm,
						codigoOrdenCompra: lineaBackend.codigoOrdenCompra || lineaBackend.CODIGO_ORDEN_COMPRA || '',
						fechaEntregaAprox: lineaBackend.fechaEntregaAprox || lineaBackend.FECHA_ENTREGA_APROX || ''
					}
					keysLineasAñadidas.add(keyLinea)
					grupo.lineas.push(linea)
					grupo.lineasVisibles.push(linea)
					gruposConDatos.add(grupo.id)
				}
			})

			if (this.propuesta.tipo === 'PUENTE') {
				this.secciones.forEach(seccion => {
					if (seccionesConDatos.has(seccion.id)) seccion.visible = true
					seccion.grupos.forEach(grupo => {
						if (gruposConDatos.has(`${seccion.id}-${grupo.id}`)) grupo.visible = true
					})
				})
			} else {
				this.grupos.forEach(grupo => {
					if (gruposConDatos.has(grupo.id)) grupo.visible = true
				})
			}
		},
		toggleGrupo(grupoId) {
			const grupo = this.grupos.find(g => g.id === grupoId)
			if (grupo) grupo.visible = !grupo.visible
		},
		toggleGrupoPuente(seccionId, grupoId) {
			const seccion = this.secciones.find(s => s.id === seccionId)
			if (!seccion) return
			const grupo = seccion.grupos.find(g => g.id === grupoId)
			if (grupo) grupo.visible = !grupo.visible
		},
		toggleSeccion(seccionId) {
			const seccion = this.secciones.find(s => s.id === seccionId)
			if (seccion) seccion.visible = !seccion.visible
		},
		contarLineasGrupo(grupo) {
			return grupo && grupo.lineasVisibles ? grupo.lineasVisibles.length : 0
		},
		contarLineasSeccion(seccion) {
			let total = 0
			;(seccion.grupos || []).forEach(grupo => { total += this.contarLineasGrupo(grupo) })
			return total
		},
		normalizarProveedorOfertaIds(proveedorOfertaIds, proveedorOfertaId) {
			if (Array.isArray(proveedorOfertaIds) && proveedorOfertaIds.length) {
				return proveedorOfertaIds.map(id => Number(id)).filter(n => !isNaN(n))
			}
			if (proveedorOfertaId != null && proveedorOfertaId !== '') {
				const n = Number(proveedorOfertaId)
				return isNaN(n) ? [] : [n]
			}
			return []
		},
		normalizarEstadoLinea(estado) {
			const n = Number(estado)
			if (!isNaN(n) && n >= 1 && n <= 4) return n
			const s = String(estado || '').trim().toLowerCase()
			if (s === 'pendiente') return 1
			if (s === 'aceptado' || s === 'aprobado') return 2
			if (s === 'no aceptado' || s === 'rechazado') return 3
			if (s === 'stock almacen' || s === 'stock almacén') return 4
			return 1
		},
		labelEstado(estado) {
			const n = Number(estado)
			if (n === 1) return 'Pendiente'
			if (n === 2) return 'Aceptado'
			if (n === 3) return 'No Aceptado'
			if (n === 4) return 'Stock Almacén'
			return 'Pendiente'
		},
		formatFechaEntrega(fecha) {
			if (!fecha) return '-'
			const s = String(fecha).trim()
			if (!s) return '-'
			const iso = s.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : s
			const parts = iso.split('-')
			if (parts.length === 3 && parts[0].length === 4) {
				return `${parts[2]}/${parts[1]}/${parts[0]}`
			}
			return s
		},
		async descargarDocumentoLinea(linea) {
			const idLinea = linea.idLineaPropuesta || linea.id
			if (!idLinea) {
				this.$message.warning('No hay documento para descargar')
				return
			}
			try {
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}
				const url = `${endpoints.backend}entidad/lineas_propuesta_pedido/${idLinea}/descargarDocumento`
				const response = await axios.post(url, null, { responseType: 'blob' })
				const blob = response.data
				if (!(blob instanceof Blob)) {
					this.$message.error('La respuesta no es un archivo válido')
					return
				}
				const contentType = response.headers['content-type'] || ''
				if (contentType.indexOf('application/json') !== -1) {
					this.$message.error('No se pudo descargar el documento')
					return
				}
				const contentDisposition = response.headers['content-disposition']
				let nombre = 'documento-linea'
				if (contentDisposition) {
					const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
					if (match && match[1]) nombre = match[1].replace(/['"]/g, '').trim()
				}
				const link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				link.download = nombre
				link.click()
				window.URL.revokeObjectURL(link.href)
				this.$message.success('Descarga iniciada')
			} catch (error) {
				console.error('Error al descargar documento:', error)
				this.$message.error(error.response && error.response.status === 404 ? 'Documento no encontrado' : 'Error al descargar el documento')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
/* Reutiliza estilos de GestionarPropuestasCompras.vue */
.propuesta-historica-page {
	.subcampo {
		font-size: 11px;
		color: #909399;
		margin-top: 2px;
	}
}

/* Copia de estilos (parcial/total) del original para mantener layout */
.gestionar-propuestas-compras-page {
	padding: 0;
}

.propuesta-container {
	padding: 20px;
}

.propuesta-header {
	background: #fff;
	padding: 15px;
	border-radius: 4px;
	margin-bottom: 20px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.propuesta-header .header-row {
	display: grid;
	grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
	gap: 15px;
	margin-bottom: 15px;
	align-items: center;
}

.header-field label {
	font-size: 12px;
	font-weight: 600;
	color: #606266;
	display: block;
	margin-bottom: 4px;
}

.header-title h2 {
	margin: 0;
	font-size: 16px;
	text-align: center;
}

.propuesta-actions {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 10px;
}

.propuesta-actions-buttons {
	display: flex;
	gap: 8px;
	align-items: center;
}

.propuesta-table-container {
	background: #fff;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
	overflow: auto;
}

.table-header,
.table-row {
	display: grid;
	align-items: center;
	padding: 0;
	gap: 0;
}

.table-header {
	grid-template-columns: 80px 200px 1fr 80px 80px 110px 120px 100px 0.7fr 1fr 110px 130px;
	background-color: $--color-main-header;
	color: white;
	font-weight: bold;
	font-size: 0.85rem;
	padding: 0.5rem;
	border-bottom: 2px solid $--color-main-header;
}

/* .table-row: bordes + grid definidos en .grupo-section .table-row */

.grupo-header {
	color: #000;
	font-weight: bold;
	padding: 0.75rem 1rem;
	border-bottom: 1px solid #dcdfe6;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	transition: all 0.2s;
	font-size: 0.9rem;
	position: relative;
}

.seccion-header {
	color: white;
	font-weight: bold;
	padding: 1rem;
	border-bottom: 2px solid rgba(0, 0, 0, 0.2);
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	transition: all 0.2s;
	font-size: 1.1rem;
}

.grupo-collapsed {
	opacity: 0.9;
}

@media (max-width: 768px) {
	.propuesta-header .header-row {
		grid-template-columns: 1fr;
	}

	.table-header,
	.table-row {
		grid-template-columns: 60px 165px 1fr 60px 60px 80px 90px 80px 0.7fr 1fr 90px 110px;
		font-size: 0.85rem;
	}
}

/* Colores de secciones y grupos (copiados de GestionarPropuestasCompras.vue) */
.seccion-cubierta .grupo-section {
	border-color: #f44336; /* Rojo para CUBIERTA */
}
.seccion-fonda .grupo-section {
	border-color: #4caf50; /* Verde para FONDA */
}
.seccion-puente .grupo-section {
	border-color: #2196f3; /* Azul para PUENTE */
}
.seccion-cubierta .seccion-header {
	background-color: #f44336; /* Rojo para CUBIERTA */
	border-bottom-color: #d32f2f;
}
.seccion-fonda .seccion-header {
	background-color: #4caf50; /* Verde para FONDA */
	border-bottom-color: #388e3c;
}
.seccion-puente .seccion-header {
	background-color: #2196f3; /* Azul para PUENTE */
	border-bottom-color: #1976d2;
}

/* Asegurar texto/icons visibles sobre cabecera coloreada */
.seccion-header {
	color: white;
}
.seccion-header i {
	color: white;
}

/* Colores de fondo por grupo (MAQUINAS) */
.grupo-ag {
	.grupo-header {
		background-color: #b3d9ff;
	}
	.table-row {
		background-color: rgba(179, 217, 255, 0.2);
	}
}
.grupo-bm {
	.grupo-header {
		background-color: #c8e6c9;
	}
	.table-row {
		background-color: rgba(200, 230, 201, 0.2);
	}
}
.grupo-cf {
	.grupo-header {
		background-color: #ffe0b2;
	}
	.table-row {
		background-color: rgba(255, 224, 178, 0.2);
	}
}
.grupo-ca {
	.grupo-header {
		background-color: #f8bbd0;
	}
	.table-row {
		background-color: rgba(248, 187, 208, 0.2);
	}
}
.grupo-dp {
	.grupo-header {
		background-color: #b2dfdb;
	}
	.table-row {
		background-color: rgba(178, 223, 219, 0.2);
	}
}
.grupo-el {
	.grupo-header {
		background-color: #fff9c4;
	}
	.table-row {
		background-color: rgba(255, 249, 196, 0.2);
	}
}
.grupo-fl {
	.grupo-header {
		background-color: #e1bee7;
	}
	.table-row {
		background-color: rgba(225, 190, 231, 0.2);
	}
}
.grupo-fr {
	.grupo-header {
		background-color: #b3e5fc;
	}
	.table-row {
		background-color: rgba(179, 229, 252, 0.2);
	}
}
.grupo-ga {
	.grupo-header {
		background-color: #c5cae9;
	}
	.table-row {
		background-color: rgba(197, 202, 233, 0.2);
	}
}
.grupo-ep {
	.grupo-header {
		background-color: #ffe082;
	}
	.table-row {
		background-color: rgba(255, 224, 130, 0.2);
	}
}
.grupo-he {
	.grupo-header {
		background-color: #dcedc8;
	}
	.table-row {
		background-color: rgba(220, 237, 200, 0.2);
	}
}
.grupo-hi {
	.grupo-header {
		background-color: #d1c4e9;
	}
	.table-row {
		background-color: rgba(209, 196, 233, 0.2);
	}
}
.grupo-hd {
	.grupo-header {
		background-color: #b2ebf2;
	}
	.table-row {
		background-color: rgba(178, 235, 242, 0.2);
	}
}
.grupo-mt {
	.grupo-header {
		background-color: #e0e0e0;
	}
	.table-row {
		background-color: rgba(224, 224, 224, 0.3);
	}
}
.grupo-mo {
	.grupo-header {
		background-color: #cfd8dc;
	}
	.table-row {
		background-color: rgba(207, 216, 220, 0.2);
	}
}
.grupo-mp {
	.grupo-header {
		background-color: #c8e6c9;
	}
	.table-row {
		background-color: rgba(200, 230, 201, 0.2);
	}
}
.grupo-pr {
	.grupo-header {
		background-color: #ffe0b2;
	}
	.table-row {
		background-color: rgba(255, 224, 178, 0.2);
	}
}
.grupo-ne {
	.grupo-header {
		background-color: #f8bbd0;
	}
	.table-row {
		background-color: rgba(248, 187, 208, 0.2);
	}
}
.grupo-pp {
	.grupo-header {
		background-color: #b2dfdb;
	}
	.table-row {
		background-color: rgba(178, 223, 219, 0.2);
	}
}
.grupo-pi {
	.grupo-header {
		background-color: #fff9c4;
	}
	.table-row {
		background-color: rgba(255, 249, 196, 0.2);
	}
}
.grupo-pc {
	.grupo-header {
		background-color: #e1bee7;
	}
	.table-row {
		background-color: rgba(225, 190, 231, 0.2);
	}
}
.grupo-qu {
	.grupo-header {
		background-color: #b3e5fc;
	}
	.table-row {
		background-color: rgba(179, 229, 252, 0.2);
	}
}
.grupo-ss {
	.grupo-header {
		background-color: #c5cae9;
	}
	.table-row {
		background-color: rgba(197, 202, 233, 0.2);
	}
}
.grupo-si {
	.grupo-header {
		background-color: #ffe082;
	}
	.table-row {
		background-color: rgba(255, 224, 130, 0.2);
	}
}
.grupo-sb {
	.grupo-header {
		background-color: #dcedc8;
	}
	.table-row {
		background-color: rgba(220, 237, 200, 0.2);
	}
}
.grupo-tr {
	.grupo-header {
		background-color: #d1c4e9;
	}
	.table-row {
		background-color: rgba(209, 196, 233, 0.2);
	}
}
.grupo-va {
	.grupo-header {
		background-color: #b2ebf2;
	}
	.table-row {
		background-color: rgba(178, 235, 242, 0.2);
	}
}
.grupo-vr {
	.grupo-header {
		background-color: #d9e1f2;
	}
	.table-row {
		background-color: rgba(217, 225, 242, 0.2);
	}
}

/* Colores de fondo por grupo para PUENTE (extra) */
.grupo-cj {
	.grupo-header {
		background-color: #ebeef1;
	}
	.table-row {
		background-color: rgba(235, 238, 241, 0.3);
	}
}
.grupo-ch {
	.grupo-header {
		background-color: #e2efda;
	}
	.table-row {
		background-color: rgba(226, 239, 218, 0.2);
	}
}
.grupo-hf {
	.grupo-header {
		background-color: #fce4d6;
	}
	.table-row {
		background-color: rgba(252, 228, 214, 0.2);
	}
}
.grupo-jp {
	.grupo-header {
		background-color: #d9e1f2;
	}
	.table-row {
		background-color: rgba(217, 225, 242, 0.2);
	}
}
.grupo-ql {
	.grupo-header {
		background-color: #fce4d6;
	}
	.table-row {
		background-color: rgba(252, 228, 214, 0.2);
	}
}
.grupo-li {
	.grupo-header {
		background-color: #d9e1f2;
	}
	.table-row {
		background-color: rgba(217, 225, 242, 0.2);
	}
}
.grupo-me {
	.grupo-header {
		background-color: #e2efda;
	}
	.table-row {
		background-color: rgba(226, 239, 218, 0.2);
	}
}
.grupo-ll {
	.grupo-header {
		background-color: #e2efda;
	}
	.table-row {
		background-color: rgba(226, 239, 218, 0.2);
	}
}
.grupo-se {
	.grupo-header {
		background-color: #fce4d6;
	}
	.table-row {
		background-color: rgba(252, 228, 214, 0.2);
	}
}

/* Reglas específicas VARIOS (según original) */
.seccion-puente .grupo-vr {
	.grupo-header {
		background-color: #ebeef1;
	}
	.table-row {
		background-color: rgba(235, 238, 241, 0.3);
	}
}
.seccion-fonda .grupo-vr {
	.grupo-header {
		background-color: #fce4d6;
	}
	.table-row {
		background-color: rgba(252, 228, 214, 0.2);
	}
}

/* Reglas base (bordes + grid + color cabecera) - desde GestionarPropuestasCompras.vue */
.gestionar-propuestas-compras-page {
	height: 100%;
	min-height: 0;
	overflow: auto;
	background-color: $--color-background;
}

.propuesta-container {
	padding: 20px;
}

.propuesta-header {
	background-color: white;
	padding: 15px;
	border-radius: 4px;
	margin-bottom: 20px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	.header-row {
		display: grid;
		grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
		gap: 15px;
		margin-bottom: 15px;
		align-items: center;
	}

	.header-field {
		label {
			display: block;
			font-weight: bold;
			margin-bottom: 5px;
			font-size: 0.9rem;
		}

		&.header-title {
			text-align: center;
			h2 {
				margin: 0;
				font-size: 1.2rem;
				color: $--color-primary;
			}
		}
	}

	.propuesta-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		padding-top: 10px;
		border-top: 1px solid #eee;
	}

	.propuesta-actions-buttons {
		display: flex;
		gap: 10px;
	}
}

.propuesta-table-container {
	background-color: white;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
	overflow: auto;
}

.table-header {
	display: grid;
	grid-template-columns: 80px 200px 1fr 80px 80px 110px 120px 100px 0.7fr 1fr 110px 130px;
	background-color: $--color-main-header;
	color: white;
	font-weight: bold;
	font-size: 0.85rem;
	padding: 0.5rem;
	border-bottom: 2px solid $--color-main-header;

	> div {
		padding: 0.25rem;
		display: flex;
		align-items: center;
	}
}

.grupo-section {
	border: 2px solid transparent;

		.table-row {
		display: grid;
			grid-template-columns: 80px 200px 1fr 80px 80px 110px 120px 100px 0.7fr 1fr 110px 130px;
		border-bottom: 1px solid #c0c4cc;
		transition: background-color 0.2s;

		&:hover {
			background-color: rgba($--color-header, 0.05);
		}

		> div {
			padding: 0.5rem;
			display: flex;
			align-items: center;
			border-right: 1px solid #c0c4cc;

			&:last-child {
				border-right: none;
			}
		}

		.col-posicion {
			justify-content: center;
		}

		.col-referencia {
			min-width: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.col-ped-barco,
		.col-ped-compras {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 6px;
		}
	}

	.grupo-header {
		color: #000;
		font-weight: bold;
		padding: 0.75rem 1rem;
		border-bottom: 1px solid #dcdfe6;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 0.9rem;
		position: relative;

		&:hover {
			opacity: 0.85;
		}

		&.grupo-collapsed {
			opacity: 0.9;
		}

		i {
			font-size: 0.9rem;
			color: #000;
			font-weight: bold;
		}

		.grupo-nombre {
			font-weight: bold;
		}
	}
}

.seccion-section {
	margin-bottom: 1rem;

	.seccion-header {
		color: white;
		font-weight: bold;
		padding: 1rem;
		border-bottom: 2px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 1.1rem;

		&:hover {
			opacity: 0.9;
		}

		&.seccion-collapsed {
			opacity: 0.8;
		}

		i {
			font-size: 1rem;
			color: white;
			font-weight: bold;
		}

		.seccion-nombre {
			font-weight: bold;
		}
	}
}

/* Bordes y colores según sección (PUENTE/FONDA/CUBIERTA) */
.seccion-cubierta .grupo-section {
	border-color: #f44336; /* Rojo para CUBIERTA */
}
.seccion-fonda .grupo-section {
	border-color: #4caf50; /* Verde para FONDA */
}
.seccion-puente .grupo-section {
	border-color: #2196f3; /* Azul para PUENTE */
}

.seccion-cubierta .seccion-header {
	background-color: #f44336; /* Rojo para CUBIERTA */
	border-bottom-color: #d32f2f;
}
.seccion-fonda .seccion-header {
	background-color: #4caf50; /* Verde para FONDA */
	border-bottom-color: #388e3c;
}
.seccion-puente .seccion-header {
	background-color: #2196f3; /* Azul para PUENTE */
	border-bottom-color: #1976d2;
}

@media (max-width: 768px) {
	.propuesta-header .header-row {
		grid-template-columns: 1fr;
	}

	.table-header,
	.grupo-section .table-row {
		grid-template-columns: 60px 165px 1fr 60px 60px 80px 90px 80px 0.7fr 1fr 90px 110px;
		font-size: 0.85rem;
	}
}

// Campos no editables: texto legible (Element UI usa #c0c4cc en .is-disabled)
.propuesta-historica-page ::v-deep .el-input.is-disabled .el-input__inner,
.propuesta-historica-page ::v-deep .el-textarea.is-disabled .el-textarea__inner,
.propuesta-historica-page ::v-deep .el-input-number.is-disabled .el-input__inner {
	color: #606266;
}
</style>

